// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gfa7","comment":"styles_comment__1gq8c"};